module.exports = __webpack_public_path__ + "5.0.2/img/tbox.9ebdc83a.png";